import type { PropsWithChildren } from 'react';

import styles from './JoinPageHeader.module.scss';
export const JoinPageHeader = ({ children }: PropsWithChildren) => {
  return <header className={styles.header}>{children}</header>;
};
